import { Grid, withStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { getAllMessages } from "./actions";
import { DatePicker } from "@material-ui/pickers";
import { ACTIVITY_PAGES } from "constants/activity.constants";

const styles = (theme) => ({
  searchBox: {
    flexBasis: "100%",
    flex: "1 1 auto",
    "& label, input": {
      fontSize: 16,
      fontFamily: "Sofia",
    },
  },
});
function ActivityDatePicker({
  classes,
  startTime,
  endTime,
  setStartTime,
  setEndTime,
  isActivityPage = true,
  page
}) {
  //   const [startTime, setStartTime] = useState(null);
  //   const [endTime, setEndTime] = useState(null);
  const dispatch = useDispatch();
  return (
    <>
      <Grid className={classes.searchBox}>
        <DatePicker
          fullWidth
          className={classes.timeSelector}
          label="Start Date"
          clearable={true}
          clearLabel={new Date(
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000
          ).toLocaleDateString()}
          ampm={true}
          format="MM/dd/yyyy"
          minutesStep={5}
          value={startTime}
          disableFuture
          onChange={(value) => {
            // setStartTime(value !== null ? value.toJSDate() : null);
            if (typeof setStartTime === "function") {
              setStartTime(value);
              if (isActivityPage && page !== ACTIVITY_PAGES.CHAT_ACTIVITY) {
                dispatch(
                  getAllMessages({
                    force: true,
                    // scrollEnd: true,
                    start:
                      value !== null ? new Date(value.toJSDate()) : undefined,
                    end: endTime ? new Date(endTime) : undefined,
                  })
                );
              }
            }
            // setState({ initLoadNumber: 0 });
          }}
          emptyLabel={new Date(
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000
          ).toLocaleDateString()}
          placeholder="Start Time"
        />
      </Grid>
      <Grid className={classes.searchBox}>
        <DatePicker
          fullWidth
          className={classes.timeSelector}
          label="End Date"
          clearable={true}
          clearLabel="Today"
          ampm={true}
          format="MM/dd/yyyy"
          minutesStep={5}
          value={endTime}
          disableFuture
          onChange={(value) => {
            // setEndTime(value !== null ? value.toJSDate() : null);
            if (typeof setEndTime === "function") {
              setEndTime(value);
              // console.log("WIPP: Using this End time",value !== null ? new Date(value.toJSDate()) : undefined )
              if (isActivityPage && page !== ACTIVITY_PAGES.CHAT_ACTIVITY) {
                dispatch(
                  getAllMessages({
                    force: true,
                    // scrollEnd: true,
                    start: startTime ? new Date(startTime) : undefined,
                    end:
                      value !== null ? new Date(value.toJSDate()) : undefined,
                  })
                );
              }
            }
            // this.setState({ initLoadNumber: 0 });
          }}
          emptyLabel={new Date().toLocaleDateString()}
          placeholder="End Time"
        />
      </Grid>
    </>
  );
}

export default withStyles(styles)(ActivityDatePicker);
